export default __webpack_public_path__ + "static/media/ic_shopping-cart.5a3e128d.svg";